import React from 'react';
import { connect } from 'react-redux';
// Game(kit) imports
import LoadScreen from '../../../../GameKitUI/components/Default/loadScreen';

class PlayerLoadScreen extends React.Component {
    render() {
        const { loading, onComplete } = this.props;

        return (
            <LoadScreen 
                className="gameplayer-loading-screen"
                title="GamePlayer Laden"
                progress={loading.progress}
                text={loading.text}
                complete={loading.complete}
                onComplete={onComplete}
            />
        );
    }
}

PlayerLoadScreen.defaultProps = {
    onComplete: () => {}
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    loading: state.loading
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerLoadScreen);
